import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination, Thumbs } from 'swiper/modules';

/**
 * Swiper component
 *
 * Les options de l'instance sont exposées via le getter `swiperOptions` pour que les
 * composants qui en héritent puissent les compléter sans redéfinir `mounted`.
 */
export default class SwiperComponent extends withBreakpointObserver(Base) {
  static config = {
    name: 'Swiper',
    refs: ['slider', 'prev', 'next', 'pagination', 'thumbs'],
    options: {
      pagination: {
        type: String,
        default: 'bullets',
      },
      spaceBetween: {
        type: Number,
        default: 0,
      },
      slidesPerView: {
        type: Number,
        default: 0,
      },
      autoplay: {
        type: Boolean,
        default: false,
      },
      autoplayDelay: {
        type: Number,
        default: 3000,
      },
      thumbsSpaceBetween: {
        type: Number,
        default: 8,
      },
      /** Centre le slide actif, équivalent du mode `center` de l'ancien slider. */
      centered: {
        type: Boolean,
        default: false,
      },
      /** `slide` ou `fade`. */
      effect: {
        type: String,
        default: 'slide',
      },
    },
  };

  /**
   * Options passées à l'instance Swiper.
   * @returns {object}
   */
  get swiperOptions() {
    const { $options, $refs } = this;

    return {
      modules: [Navigation, Pagination, Autoplay, Thumbs, EffectFade],
      slidesPerView: 'auto',
      grabCursor: true,
      centeredSlides: $options.centered,
      effect: $options.effect,
      fadeEffect: { crossFade: true },
      spaceBetween: $options.spaceBetween,
      autoplay: $options.autoplay ? { delay: $options.autoplayDelay } : false,
      navigation: {
        nextEl: $refs.next,
        prevEl: $refs.prev,
      },
      pagination: {
        clickable: true,
        el: $refs.pagination,
        type: $options.pagination,
      },
      thumbs: this.thumbs ? { swiper: this.thumbs } : undefined,
      breakpoints: {
        1024: {
          slidesPerView: $options.slidesPerView > 0 ? $options.slidesPerView : 'auto',
        },
      },
    };
  }

  /**
   *
   */
  mounted() {
    if (this.$refs.thumbs) {
      this.thumbs = new Swiper(this.$refs.thumbs, {
        slidesPerView: 'auto',
        spaceBetween: this.$options.thumbsSpaceBetween,
        watchSlidesProgress: true,
      });
    }

    this.slider = new Swiper(this.$refs.slider, this.swiperOptions);
  }

  /**
   *
   */
  destroyed() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
    if (this.thumbs) {
      this.thumbs.destroy(true, true);
      this.thumbs = null;
    }
  }
}
